import "animate.css";
import { Col, Container, Nav, Row, Tab } from "react-bootstrap";
import dragonQuestLogo from "../assets/img/Dragon Quest Banner Website.jpg";
import finecheckLogo from "../assets/img/finecheck-logo.jpg";
import golftickLogo from "../assets/img/golftick-logo-8.jpeg";
/* import photographyWebsiteImg from "../assets/img/Logo-luca-liam-photography.png"; */
import twitterTrendAnalyzerLogo from "../assets/img/twitter-trend-analyzer-logo-smaller.png";
import weatherMindLogo from "../assets/img/WeatherMind-Logo.jpeg";
import scienceprojectImg from "../assets/img/Wissenschaftspreis-logo-hell.jpeg";
import { ProjectCard } from "./ProjectCard";

export const Projects = () => {
  const projects = [
    {
      title: "FineCheck",
      description: `Finanz-Tracker-App zur Verwaltung Ihrer Einnahmen, Ausgaben, Kategorien, zum Festlegen von Zielen/Limits und vielem mehr...`,
      technologies: "Technologies: React, TypeScript, Chakra UI",
      imgUrl: finecheckLogo,
      projectUrl: "https://finecheck.luca-schaefer.com",
    },
    {
      title: "GolfTick",
      description:
        "Golfplätze in der Nähe suchen, abhaken und auf die To-do-Liste setzen. Sammle Plätze, bewerte diese und trage Scores ein und mithilfe eines Dashboards behälst du den Überblick. Alles in einer App",
      technologies: "Technologies: React, Chakra UI, CSS",
      imgUrl: golftickLogo,
      projectUrl: "https://golftick.luca-schaefer.com",
    },
    {
      title: "Tweet Trend Analyzer",
      description: `Ein interaktives Analyse-Tool zur Darstellung von täglicher Hashtag-Trends aus Twitter-Datensätzen, mit Fokus auf zeitliche Entwicklungen, Vergleichbarkeit und Visualisierung.`,
      technologies:
        "Technologies: Python (Fast-API), Next.js, Recharts, Tailwind CSS",
      imgUrl: twitterTrendAnalyzerLogo,
      projectUrl: "https://tweets-trend-analyzer.luca-schaefer.com/",
    },
    {
      title: "WeatherMind",
      description:
        "Eine Web-App rund ums Thema Wetter. Aktuelle Wetterdaten, Vorhersagen und vieles mehr... Verwendete API: OpenWeather-API Status des Projekts: -In Bearbeitung-",
      technologies:
        "Technologies: React, TypeScript, Shadcn, Tailwind, Recharts, Vite",
      imgUrl: weatherMindLogo,
      projectUrl: "https://weathermind.luca-schaefer.com",
    },
    {
      title: "Dragon Quest RPG Decision Game",
      description: `Lustiges, CLI angelehntes, Retro-Abenteuer-Entscheidungsspiel. Finde heraus, wie du den Drachen besiegen, das Dorf retten und Bestzeiten aufstellen kannst!`,
      technologies: "Technologies: JavaScript, HTML/CSS",
      imgUrl: dragonQuestLogo,
      projectUrl: "https://dragons-quest.luca-schaefer.com",
    },
    {
      title: "Teamprojekt: Wissenschaftspreis im Bereich MINT 2.Platz",
      description: `Luftqualitätsüberwachung mit einem Raspberry Pi und einem PM-Sensor.`,
      technologies: "Technologies: JavaScript, Python, C#, HTML/CSS, Swift",
      imgUrl: scienceprojectImg,
      projectUrl:
        "https://github.com/MichaelHolley/Wissenschaftspreis-2021/tree/master",
    },
  ];

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col xs={12}>
            <div>
              <h2>Projects</h2>
              <p>
                Hier sind einige ausgewählte Projekte, die ich in meiner
                Freizeit erstellt habe. Von Webanwendungen bis hin zu
                CLI-Programmen gibt es viel zu entdecken. Natürlich sind hier
                nur einige Projekte aufgeführt. Weitere Projekte und den Code
                finden Sie auf meinem{" "}
                <p style={{ textAlign: "center" }}>
                  GitHub-Account:{" "}
                  <a
                    href="https://github.com/LiamSchaefer"
                    target="_blank"
                    rel="noreferrer"
                    style={{
                      textDecoration: "none",
                      color: "rgb(13 240 253)",
                      overflowWrap: "anywhere",
                    }}
                  >
                    https://github.com/LiamSchaefer
                  </a>
                </p>
              </p>
              <Tab.Container id="projects-tabs" defaultActiveKey="first">
                <Nav
                  variant="pills"
                  className="nav-pills mb-5 justify-content-center align-items-center"
                  id="pills-tab"
                >
                  <Nav.Item>
                    <Nav.Link eventKey="first">Projekte</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="second">FineCheck</Nav.Link>
                  </Nav.Item>
                  <Nav.Item>
                    <Nav.Link eventKey="third">WeatherMind</Nav.Link>
                  </Nav.Item>
                </Nav>
                <Tab.Content>
                  <Tab.Pane eventKey="first">
                    <div style={{ display: "flex", justifyContent: "center" }}>
                      <Row className="projects-grid">
                        {projects.map((project, index) => {
                          return <ProjectCard key={index} {...project} />;
                        })}
                      </Row>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="second">
                    <div className="project-teaser">
                      <div className="project-content">
                        <div className="project-text">
                          <img
                            src={require("../assets/img/finecheck-schriftzug-black.png")}
                            alt="FineCheck Logo"
                            className="project-logo"
                          />
                          <h4> Check your finances, easy and quick.</h4>
                          <p
                            style={{
                              textAlign: "left",
                              width: "100%",
                              margin: 0,
                              marginTop: "20px",
                              color: "black",
                            }}
                          >
                            FineCheck ist eine moderne, intuitiv gestaltete
                            Web-App zur Verwaltung persönlicher Finanzen. Der
                            Schwerpunkt liegt auf der schnellen und flexiblen
                            Erfassung aller Geldflüsse. Mit hilfreichen
                            Analysen, intelligenten Dashboards und
                            automatisierten Diagrammen bietet FineCheck jedem
                            Nutzer einen klaren Überblick über Einnahmen,
                            Ausgaben, Sparziele, Budgetgrenzen und vieles Mehr.
                          </p>
                          <div className="project-highlights">
                            <p className="project-highlights-title">
                              Highlights:
                            </p>
                            <ul>
                              <li>
                                Übersichtliche Zusammenfassung von Saldo,
                                Einnahmen, Ausgaben, Limits, Sparzielen und
                                Kategorien
                              </li>
                              <li>
                                Funktionen: Die Möglichkeit, eigene Kategorien
                                zu erstellen, Sparziele und Ausgabenlimits
                                festzulegen, wiederkehrende Fixkosten anzulegen,
                                wertvolle Statistiken für eine bessere
                                Nachverfolgbarkeit der Finanzen und vieles
                                mehr...
                              </li>
                              <li>
                                Responsive Design für alle Geräte und
                                Bildschirmgrößen
                              </li>
                              <li>
                                Möglichkeit, die Webanwendung als PWA auf Ihr
                                Smartphone oder Desktop zu installieren und
                                damit auch die Offline-Nutzung für
                                Android-Geräte zu ermöglichen. Das bedeutet,
                                dass die Webanwendung auch als Smartphone oder
                                Desktop-App genutzt werden kann.
                              </li>
                            </ul>
                          </div>
                          <div className="project-techstack">
                            <p
                              style={{
                                textAlign: "left",
                                margin: 0,
                                width: "100%",
                                color: "black",
                              }}
                            >
                              <strong>Techstack:</strong>{" "}
                              <span style={{ color: "rgba(41, 41, 41, 0.75)" }}>
                                React, TypeScript, Chakra UI, Recharts
                              </span>
                            </p>
                          </div>
                          <div className="project-button-finecheck">
                            <a
                              href="https://finecheck.luca-schaefer.com"
                              target="_blank"
                              className="github-link"
                              rel="noreferrer"
                            >
                              Hier geht es zu Finecheck
                            </a>
                          </div>
                        </div>
                        <div className="project-image-wrapper">
                          {/* <ScreenshotGallery /> */}
                          <a
                            href="https://finecheck.luca-schaefer.com"
                            target="_blank"
                            rel="noreferrer"
                            className="image-link"
                          >
                            <img
                              src={require("../assets/img/ScreenshotFineCheck.png")}
                              alt="FineCheck Dashboard Screenshot"
                              className="project-screenshot"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                  <Tab.Pane eventKey="third">
                    <div className="project-teaser">
                      <div className="project-content">
                        <div className="project-text">
                          <div
                            style={{
                              display: "inline-flex",
                              alignItems: "center",
                              flexWrap: "wrap",
                            }}
                          >
                            <img
                              src={require("../assets/img/weathermind-Logo2.png")}
                              alt="Weathermind Logo"
                              className="project-logo-rounded"
                            />
                            <h3 style={{ marginLeft: "15px" }}> Weathermind</h3>
                          </div>
                          <h4>For minds that like it clear</h4>
                          <p
                            style={{
                              textAlign: "left",
                              width: "100%",
                              margin: 0,
                              marginTop: "20px",
                              color: "black",
                            }}
                          >
                            Überprüfen Sie das aktuelle Wetter, Vorhersagen,
                            Luftbedingungen und vieles mehr. Die Wetterdaten
                            stammen von der Open-Weather API. Dort finden Sie
                            5-Tage-Wettervorhersagen in 3-Stunden-Intervallen,
                            aktuelle Wetterdetails und alle notwendigen
                            Informationen, die Sie über die meteorologischen
                            Bedingungen wissen müssen.{" "}
                            <b>
                              INFO: Das Projekt ist noch in Arbeit, daher wird
                              es noch viele weitere Neuerungen und
                              Verbesserungen geben. Bleiben Sie dran!
                            </b>
                          </p>
                          <div className="project-highlights">
                            <p className="project-highlights-title">
                              Highlights:
                            </p>
                            <ul>
                              <li>
                                Minimalistische und effiziente Möglichkeit, das
                                Wetter zu überprüfen – alles, was Sie wissen
                                wollen, schnell und auf einen Blick
                              </li>
                              <li>Einfache und intuitive Benutzeroberfläche</li>
                              <li>
                                Responsive Design für alle Geräte und
                                Bildschirmgrößen
                              </li>
                              <li>
                                Möglichkeit, die WebApp als PWA auf Ihr
                                Smartphone oder Desktop zu installieren. Das
                                bedeutet, dass die Webanwendung auch als
                                Smartphone oder Desktop-App genutzt werden kann.
                              </li>
                            </ul>
                          </div>
                          <div className="project-techstack">
                            <p
                              style={{
                                textAlign: "left",
                                margin: 0,
                                width: "100%",
                                color: "black",
                              }}
                            >
                              <strong>Techstack:</strong>{" "}
                              <span style={{ color: "rgba(41, 41, 41, 0.75)" }}>
                                React, TypeScript, Shadcn, Tailwind, Vite,
                                Recharts
                              </span>
                            </p>
                          </div>
                          <div className="project-button-finecheck">
                            <a
                              href="https://weathermind.luca-schaefer.com"
                              target="_blank"
                              className="github-link"
                              rel="noreferrer"
                            >
                              Hier geht es zu Weathermind
                            </a>
                          </div>
                        </div>
                        <div className="project-image-wrapper">
                          <a
                            href="https://weathermind.luca-schaefer.com"
                            target="_blank"
                            rel="noreferrer"
                            className="image-link"
                          >
                            <img
                              src={require("../assets/img/Screenshot-weathermind4.png")}
                              alt="WeatherMind Screenshot"
                              className="project-screenshot"
                            />
                          </a>
                        </div>
                      </div>
                    </div>
                  </Tab.Pane>
                </Tab.Content>
              </Tab.Container>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};
